import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {when} from 'lit/directives/when.js';
import {connect} from 'pwa-helpers';
import {msg} from '@lit/localize';
import store from '../../store';
import {selectSolarLumPosition2IsVisible} from '../solarSelectors';

@customElement('solar-layout-settings')
export class SolarLayoutSettings extends connect(store)(LitElement) {

	static styles = [
		css`
			:host {
				display: flex;
				break-inside: avoid;
				flex-flow: column;
				place-content: flex-start;
				gap: var(--small-padding);
			}
			.box {
				background-color: var(--color-widget-background);
				padding: 12px;
				display: flex;
				break-inside: avoid;
				flex-flow: column;
				place-content: flex-start;
				gap: var(--large-space);
			}
			.boxheader {
				font: var(--font-widget-title);
				color: var(--color-widget-border);
			}
		`
	];

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
		this.lang = state.status.lang;
		this.secondLum = selectSolarLumPosition2IsVisible(state);
	}

	render() {
		return html`
			<div class="box">
				<header class="boxheader">${msg('Pole')}</header>
				<spc-attribute .attributeId=${{localId: 'HS_HousingHeight'}} .hideDisabledValues=${true}></spc-attribute>
				<spc-attribute .attributeId=${{localId: 'HS_Base'}} .hideDisabledValues=${true}></spc-attribute>
				<spc-attribute .attributeId=${{localId: 'HS_HousingColour'}} .hideDisabledValues=${false}></spc-attribute>
			</div>
			<div class="box">
				<header class="boxheader">${msg('Top Luminary')}</header>
				<spc-attribute .attributeId=${{localId: 'LE_LuminairePositionHeight_1'}} .hideDisabledValues=${true}></spc-attribute>
				<spc-attribute .attributeId=${{localId: 'LE_LightDistribution_1'}} .hideDisabledValues=${true}></spc-attribute>
			</div>
			${when(this.secondLum, () => html`
				<div class="box">
					<header class="boxheader">${msg('Bottom Luminary')}</header>
					<spc-attribute .attributeId=${{localId: 'LE_LuminairePositionHeight_2'}} .hideDisabledValues=${true}></spc-attribute>
					<spc-attribute .attributeId=${{localId: 'LE_LightDistribution_2'}} .hideDisabledValues=${true}></spc-attribute>
				</div>
			`)}
        `;
	}
}
